export default __webpack_public_path__ + "static/media/10.dd3af803.jpg";